import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import { FTUE_EVENT_TYPES, FTUE_STEPS_KEYS } from '../../constants';
import { sendFtueEvent } from '../../lib/analytics/ftueLogger';
import { skipTutorialGame } from './utils/skipTutorialGame';

var OnboardingLayer = /*#__PURE__*/function (_React$Component) {
  _inherits(OnboardingLayer, _React$Component);

  var _super = _createSuper(OnboardingLayer);

  function OnboardingLayer(props) {
    var _this;

    _classCallCheck(this, OnboardingLayer);

    _this = _super.call(this, props);
    _this.lastLoggedStepRef = React.createRef();
    _this.lastLoggedStepRef.current = 0;
    return _this;
  }

  _createClass(OnboardingLayer, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var ftueStep = this.props.ftueStep;

      if (ftueStep > FTUE_STEPS_KEYS.INITIAL && ftueStep !== this.lastLoggedStepRef.current) {
        this.lastLoggedStepRef.current = ftueStep;
        ftueStep === FTUE_STEPS_KEYS.HIGHLIGHT_A_GAME && sendFtueEvent(FTUE_EVENT_TYPES.START_FTUE_TUTORIAL);
        sendFtueEvent(FTUE_EVENT_TYPES.DISPLAY_FTUE_TUTORIAL_STEP, {
          step: ftueStep
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          position = _this$props.position,
          tooltip = _this$props.tooltip,
          ftueStep = _this$props.ftueStep,
          render = _this$props.render,
          clearOnboarding = _this$props.clearOnboarding,
          actionCommands = _this$props.actionCommands;
      if (!position) return null;
      return render(_objectSpread(_objectSpread({}, position), {}, {
        tooltip: tooltip,
        ftueStep: ftueStep,
        skipTutorial: function skipTutorial() {
          return skipTutorialGame(ftueStep, clearOnboarding, actionCommands);
        }
      }));
    }
  }]);

  return OnboardingLayer;
}(React.Component);

export { OnboardingLayer as default };